import React, { useState } from 'react';
import { SearchLocationInput } from 'components';
import CryptoJS from 'crypto-js';
import ApiMServer from 'services/ApiMServer';
import { FaBriefcase } from 'react-icons/fa';
import { formatCpfOrCnpj } from 'utils/cpfCnpj';
import {
  getModernCardBodyClass,
  getModalHeaderClass,
  getModalFooterClass,
} from 'utils/tableTheme';

import {
  Card,
  Row,
  Col,
  Form,
  FloatingLabel,
  Button,
  Modal,
} from 'react-bootstrap';

const Forms = (props) => {
  const {
    fieldChange,
    onSubmit,
    units,
    permission,
    setEmails,
    emails,
    setUnits,
    setLocation,
    theme,
    linkedCooperatives = [],
  } = props;

  const handelHash = () => {
    if (!units.secretOnlyKey) {
      const myHash = CryptoJS.SHA256(units._id).toString(CryptoJS.enc.Hex);
      units.secretOnlyKey = myHash
      setUnits({ ...units });
    }
  }

  const handleCNPJChange = (event) => {
    fieldChange(event, 'cnpj', formatCpfOrCnpj(event.target.value));
  };

  const formatPhone = (value) => {
    // Remove todos os caracteres que não são números
    value = value.replace(/\D/g, '');

    // Limita o número de caracteres para o formato de telefone brasileiro
    if (value.length > 11) {
      value = value.slice(0, 11);
    }

    // Formata o telefone com o padrão (XX) XXXX-XXXX ou (XX) XXXXX-XXXX
    if (value.length <= 10) {
      return value.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    } else {
      return value.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }
  };

  const handlePhoneChange = (event) => {
    const formattedPhone = formatPhone(event.target.value);
    fieldChange(event, 'fone', formattedPhone);
  };

  const [inputValue, setInputValue] = useState('');

  const isEmailValid = (email) => {
    // Validação simples de e-mail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // removed handleKeyDown as it was unused

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [emailToRemoveIndex, setEmailToRemoveIndex] = useState(null);

  const confirmRemoveEmail = async () => {
    if (emailToRemoveIndex !== null) {
      const emailToRemove = emails[emailToRemoveIndex];
      try {
        await ApiMServer.post('/company/rmgestor', {
          email: emailToRemove,
          id: units._id
        });
      } catch (error) {
        console.error("Erro ao remover gestor:", error);
      }
      setEmails(emails.filter((_, i) => i !== emailToRemoveIndex));
      setEmailToRemoveIndex(null);
      setShowConfirmModal(false);
    }
  };

  const openConfirmModal = (index) => {
    setEmailToRemoveIndex(index);
    setShowConfirmModal(true);
  };

  return (
    <Card className='mb-3 mt-3'>
      <Card.Header>
        <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Dados da Unidade</h5>
      </Card.Header>
      <Card.Body>
        <Form>
          <Row className="g-2">

            <Col md>
              <FloatingLabel controlId="floatingInput" label="Nome" className="mb-3">
                <Form.Control
                  type="text"
                  name="Nome"
                  placeholder="Nome"
                  onChange={event =>
                    fieldChange(event, 'name', event.target.value)
                  }
                  value={units.name}
                  disabled={!permission}
                />
              </FloatingLabel>
            </Col>

            <Col md>
              <FloatingLabel controlId="floatingInput" label="CPF/CNPJ" className="mb-3">
                <Form.Control
                  type="text"
                  name="cnpj"
                  placeholder="CPF/CNPJ"
                  onChange={handleCNPJChange}
                  value={units.cnpj}
                  maxLength={18}
                  disabled={!permission}
                />
              </FloatingLabel>
            </Col>

            <Col md>
              <FloatingLabel controlId="floatingInput" label="Telefone" className="mb-3">
                <Form.Control
                  type="text"
                  name="Telefone"
                  placeholder="Telefone"
                  onChange={handlePhoneChange}
                  value={units.fone}
                  disabled={!permission}
                />
              </FloatingLabel>
            </Col>

          </Row>

          <Row className="g-2">
            <Col md>
              <SearchLocationInput
                setLocation={setLocation}
                addr={units.address}
              />
            </Col>

            <Col md>
              <FloatingLabel controlId="floatingInput" label="Número do Contrato de Locação" className="mb-3">
                <Form.Control
                  type="text"
                  name="Número do Contrato de Locação"
                  placeholder="Número do Contrato de Locação"
                  onChange={event =>
                    fieldChange(event, 'ncontract', event.target.value)
                  }
                  value={units.ncontract}
                  disabled={!permission}
                />
              </FloatingLabel>
            </Col>

            <Col md>
              <FloatingLabel controlId="floatingInput" label="E-mail" className="mb-3">
                <Form.Control
                  type="text"
                  name="E-mail"
                  placeholder="E-mail"
                  onChange={event =>
                    fieldChange(event, 'email', event.target.value.trim().toLowerCase())
                  }
                  value={units.email}
                  disabled={!permission}
                />
              </FloatingLabel>
            </Col>
          </Row>

          <Row className="g-2">
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Domínio de E-mail da empresa" className="mb-3">
                <Form.Control
                  type="text"
                  name="Domínio de E-mail da empresa"
                  placeholder="Domínio de E-mail da empresa"
                  onChange={event =>
                    fieldChange(event, 'dominioEmail', event.target.value.trim().toLowerCase())
                  }
                  value={units?.dominioEmail}
                  disabled={!permission}
                />
              </FloatingLabel>
            </Col>

            <Col md>
              <FloatingLabel controlId="floatingInput" label="Chave única API externa" className="mb-3">
                <Form.Control
                  type="text"
                  name="Chave única API externa"
                  placeholder="Chave única API externa"
                  value={units.secretOnlyKey}
                  disabled
                />
              </FloatingLabel>
            </Col>
          </Row>

          <Row className="g-2">
            <Col md={12}>
              <div className={`mb-3 p-3 border rounded ${theme === 'dark' ? 'border-secondary bg-dark' : 'bg-light'}`}>
                <p className={`mb-2 fw-bold d-flex align-items-center gap-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>
                  <FaBriefcase /> Matriz
                </p>
                {linkedCooperatives.length > 0 ? (
                  <div className={`d-flex flex-column gap-1 ${theme === 'dark' ? 'text-light' : 'text-dark'}`} style={{ fontSize: '0.95rem' }}>
                    {linkedCooperatives.map((cooperative) => (
                      <span key={cooperative._id || cooperative.name}>
                        Unidade vinculada a matriz {cooperative.name}
                      </span>
                    ))}
                  </div>
                ) : (
                  <span className={`text-muted ${theme === 'dark' ? 'opacity-75' : ''}`} style={{ fontSize: '0.9rem' }}>
                    Unidade não vinculada a nenhuma matriz.
                  </span>
                )}
              </div>
            </Col>
          </Row>

          <Row className="g-2">
            <Col md={12}>
              <div className={`mb-3 p-3 border rounded ${theme === 'dark' ? 'border-secondary bg-dark' : 'bg-light'}`}>
                <p className={`mb-2 fw-bold d-flex align-items-center gap-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>
                  <span role="img" aria-label="gestores">👥</span> Gestores Vinculados
                </p>
                {emails && emails.length > 0 ? (
                  <div className="d-flex flex-wrap gap-2">
                    {emails.map((email, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center px-3 py-1 bg-success text-white rounded-pill shadow-sm"
                        style={{ fontSize: '0.9rem' }}
                      >
                        <span className="me-2 fw-medium">{email}</span>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            cursor: permission ? 'pointer' : 'not-allowed',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            transition: 'all 0.2s ease',
                            opacity: permission ? 1 : 0.5
                          }}
                          onClick={() => permission && openConfirmModal(index)}
                          onMouseEnter={(e) => permission && (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.5)')}
                          onMouseLeave={(e) => permission && (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)')}
                          title={permission ? "Remover gestor" : "Sem permissão"}
                        >
                          <span style={{ fontSize: '1.2rem', lineHeight: 1, paddingBottom: '2px' }}>×</span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <span className={`text-muted ${theme === 'dark' ? 'opacity-75' : ''}`} style={{ fontSize: '0.9rem' }}>Nenhum gestor vinculado.</span>
                )}
              </div>
            </Col>
          </Row>

          <Row className="align-items-center g-2 mb-3">
            <Col xs={12} md="auto">
              <Form.Check
                isValid
                type="checkbox"
                label="Acesso API externa"
                disabled={!permission}
                checked={units.accessSecretOnlyKey}
                onChange={event => {
                  handelHash();
                  fieldChange(event, 'accessSecretOnlyKey', !units.accessSecretOnlyKey);
                }}
              />
            </Col>
            <Col xs={12} md="auto">
              <Form.Check
                isValid
                type="checkbox"
                label="Restringir ativação a usuários da empresa"
                disabled={!permission}
                checked={units.restrictAcess}
                onChange={event =>
                  fieldChange(event, 'restrictAcess', !units.restrictAcess)
                }
              />
            </Col>
          </Row>

        </Form>

        <Row className='g-2'>
          <Col xs="auto">
            <Button
              disabled={!permission}
              onClick={() => onSubmit()}
              variant="success"
            >
              Salvar
            </Button>
          </Col>
        </Row>

      </Card.Body>

      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header
          closeButton
          closeVariant={theme === 'dark' ? 'white' : undefined}
          className={getModalHeaderClass(theme)}
        >
          <Modal.Title>Confirmar Remoção</Modal.Title>
        </Modal.Header>
        <Modal.Body className={getModernCardBodyClass(theme)}>
          Tem certeza de que deseja remover este e-mail ({emailToRemoveIndex !== null ? emails[emailToRemoveIndex] : ''}) da lista de gestores?
        </Modal.Body>
        <Modal.Footer className={getModalFooterClass(theme)}>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmRemoveEmail}>
            Remover
          </Button>
        </Modal.Footer>
      </Modal>

    </Card>
  )
}
export default Forms;
